module.exports = __webpack_public_path__ + "img/pintai.10c25731.png";